import { Loader2 } from 'lucide-react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'src/components/ui/table';
import type { CreativeTemplate } from '../types/creative-template.types';

interface CreativeTemplateListProps {
  templates: CreativeTemplate[] | undefined;
  isLoading: boolean;
  isError: boolean;
  onSelect: (template: CreativeTemplate) => void;
}

export function CreativeTemplateList({
  templates,
  isLoading,
  isError,
  onSelect,
}: CreativeTemplateListProps) {
  if (isLoading) {
    return (
      <div className="flex items-center gap-2 py-8 text-sm text-gray-500" role="status">
        <Loader2 className="size-4 animate-spin text-gray-500" />
        Loading creative templates…
      </div>
    );
  }

  if (isError) {
    return (
      <div className="rounded-md border border-red-101 bg-red-101 p-4 text-sm text-red-700" role="alert">
        Could not load creative templates. You may need staff or admin access.
      </div>
    );
  }

  if (!templates?.length) {
    return (
      <div className="rounded-md border border-gray-400 bg-gray-50 p-4 text-sm text-gray-600">
        No creative templates found. Run the seed command or create a new template.
      </div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Template</TableHead>
          <TableHead>Roles</TableHead>
          <TableHead>Breakpoints</TableHead>
          <TableHead>Version</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {templates.map((template) => (
          <TableRow key={template.id} className="cursor-pointer" onClick={() => onSelect(template)}>
            <TableCell>
              <div className="font-medium text-black">{template.payload.name}</div>
              <div className="text-sm text-gray-500">{template.template_id}</div>
            </TableCell>
            <TableCell>{template.payload.roles.length}</TableCell>
            <TableCell>{template.payload.breakpoints.length}</TableCell>
            <TableCell>{template.version ?? '—'}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
